<template>
	<b-form
		ref="form"
		@submit.prevent="setContactPost"
	>

		<b-card
			no-body
			class="mb-1"
		>

			<b-card-header
				header-tag="header"
				class="p-1"
				role="tab"
			>
				<label>
					<input
						type="radio"
						checked
						name="creating"
						value="false"
						v-model="creating"
						v-b-toggle.accordion-1
					/>

					Find existing</label>

			</b-card-header>

			<b-collapse
				id="accordion-1"
				visible
				accordion="contact-accordion"
				role="tabpanel"
			>
				<b-card-body>

					<b-card-text>

						<b-form-fieldset>
							<b-form-group>
								<vue-typeahead-bootstrap
									class="mb-4"
									v-model="query"
									:data="contacts"
									:serializer="item => item.Name + ' - ' + item.Address.Town"
									@hit="setContact($event)"
									placeholder="Search existing contacts"
								/>
							</b-form-group>
						</b-form-fieldset>

					</b-card-text>

				</b-card-body>
			</b-collapse>
		</b-card>

		<b-card
			no-body
			class="mb-1"
		>

			<b-card-header
				header-tag="header"
				class="p-1"
				role="tab"
			>
				<label>
					<input
						type="radio"
						name="creating"
						value="true"
						v-model="creating"
						v-b-toggle.accordion-2
					/>
					Create new</label>

			</b-card-header>

			<b-collapse
				id="accordion-2"
				accordion="contact-accordion"
				role="tabpanel"
				visible
			>
				<b-card-body>

					<b-card-text>

						<b-row class="mt-3">

							<b-col cols="6">

								<b-form-group
									label="Name:"
									for="name"
								>

									<b-input
										id="name"
										v-model="contact.Name"
										type="text"
										required
									/>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									label="Position:"
									for="position"
								>
									<b-input
										id="position"
										v-model="contact.Position"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="12">
								<b-form-group
									label="Email:"
									for="email"
								>
									<b-input
										id="email"
										v-model="contact.EmailAddress"
										type="email"
									/>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									label="Telephone:"
									for="telephone"
								>
									<b-input
										id="telephone"
										v-model="contact.Telephone"
										type="tel"
									/>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									label="Mobile:"
									for="mobile"
								>
									<b-input
										id="mobile"
										v-model="contact.Mobile"
										type="tel"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="12">
								<b-form-group
									label="Address 1:"
									for="address1"
								>
									<b-input
										id="address1"
										v-model="contact.Address.Address1"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="12">
								<b-form-group
									label="Address 2:"
									for="address2"
								>
									<b-input
										id="address2"
										v-model="contact.Address.Address2"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="12">
								<b-form-group
									label="Address 3:"
									for="address3"
								>
									<b-input
										id="address3"
										v-model="contact.Address.Address3"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="6">
								<b-form-group
									label="Town:"
									for="town"
								>
									<b-input
										id="town"
										v-model="contact.Address.Town"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="6">
								<b-form-group
									label="County:"
									for="county"
								>
									<b-input
										id="county"
										v-model="contact.Address.County"
										type="text"
									/>
								</b-form-group>
							</b-col>

							<b-col cols="6">
								<b-form-group
									label="Postcode:"
									for="postcode"
								>
									<b-input
										id="postcode"
										v-model="contact.Address.Postcode"
										type="text"
									/>
								</b-form-group>
							</b-col>
						</b-row>

					</b-card-text>

				</b-card-body>

			</b-collapse>

		</b-card>

		<b-button
			type="submit"
			variant="info"
		>Add Contact</b-button>

	</b-form>
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import ContactService from "@/api-services/contact.service";

export default {
	name: "AddContactToParent",

	// things we want to use
	components: {
		VueTypeaheadBootstrap,
	},

	// things we have inherited from our parent
	props: [],

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function () {
		return {
			query: "",
			creating: false,

			contact: {
				Name: "",
				Postition: "",
				Telephone: "",
				Mobile: "",
				Email: "",
				Address: {},
			},
			contacts: [],
		};
	},
	// things we do to data
	methods: {
		setContactPost() {
			if (this.creating) {
				// this might have been populated by loading in an existing customer and then swapping, don't make a new guy
				if (this.contact.Id != null) {
					
					this.$emit("addContact", this.contact);
					
				} else {
					ContactService.create(this.contact)
						.then((response) => {
							this.$emit("addContact", response.data);
						})
						.catch((error) => {
							console.log(error.response.data);
						});
				}
			} else {
				this.$emit("addContact", this.contact);
			}
		},

		setContact(contact) {
			this.contact = contact;
		},
	},

	// data we watch for changes
	watch: {
		// When the query value changes, fetch new results from
		// the API - in practice this action should be debounced
		query(newQuery) {
			ContactService.search(newQuery).then((res) => {
				this.contacts = res.data;
			});
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/partials/add-contact-to-parent.vue